export default "__VITE_ASSET__D7s3seZ9__"